import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

// const getSize = (size) => {
//   switch (size) {
//     case 'small':
//       return '4px';
//     case 'large':
//       return '8px';
//     default:
//       return '6px';
//   }
// };

// const getColor = (color) => {
//   switch (color) {
//     case 'secondary':
//       return '#6B7280';
//     case 'gray':
//       return '#9CA3AF';
//     default:
//       return '#3B82F6';
//   }
// };

// const getSpeed = (speed) => {
//   switch (speed) {
//     case 'slow':
//       return '1.5s';
//     case 'fast':
//       return '0.5s';
//     default:
//       return '1s';
//   }
// };

export const ThinkingAnimationRoot = superstyled({
  name: 'InteractiveForm',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    maxWidth: '10px',
    margin: '0 auto',
    display: 'flex'
  })
});

export default ThinkingAnimationRoot;
